import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-custom-date-picker',
    templateUrl: './custom-date-picker.component.html',
    styleUrls: ['./custom-date-picker.component.scss'],
    standalone: false
})
export class CustomDatePickerComponent implements OnInit, DoCheck {

  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() fGroup: FormGroup;
  @Input() fControlName: string;
  @Input() required = true;
  @Input() hideHint = false;
  @Input() maxDate: Date;
  @Input() minDate: Date | any;
  fControl: FormControl;
  max: Date;
  min: Date;

  constructor() {}

  ngOnInit(): void {
    this.fControl = this.fGroup?.get(this.fControlName) as FormControl;
    this.max = this.maxDate || moment('12/31/9999').toDate();
    this.min = this.minDate;
  }

  ngDoCheck(): void {
    this.max = this.maxDate || moment('12/31/9999').toDate();
    this.min = this.minDate;
  }

}
